export class Channel {
    public ChannelId!: string;
    public ChannelName!: string;
    public ChannelIcon!: string;
    public OrganisationName!: string;
}
